import groq from 'groq'
import { ButtonQuery } from '../atoms/ButtonQuery'

export const ThreeColumnSectionQuery = groq`
    _type == "ThreeColumnSection" => {
      ...,
      alignment,
      innerBlocks[]{
        ...,
        _type == "button" => {
          ${ButtonQuery}
        },
      },
      innerBlocks2[]{
        ...,
        _type == "button" => {
          ${ButtonQuery}
        },
      },
      innerBlocks3[]{
        ...,
        _type == "button" => {
          ${ButtonQuery}
        },
      }
    }

`
